import { c as _c } from "react/compiler-runtime";
import { getPreservedQueryParams } from "@router/router-helper";
import { useLocation } from "react-router-dom";
/**
 *  This hook is used to preserve the search query parameters when navigating to a new page.
 * @param to  The path to navigate to.
 * @returns  An object containing the pathname and search string.
 */
export function usePreservedSearch(path) {
  const $ = _c(7);
  const location = useLocation();
  let t0;
  if ($[0] !== location.search) {
    t0 = getPreservedQueryParams(location.search);
    $[0] = location.search;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const preservedSearch = t0;
  let t1;
  if ($[2] !== path) {
    t1 = path.split("?");
    $[2] = path;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const cleanedPath = t1[0];
  let t2;
  if ($[4] !== cleanedPath || $[5] !== preservedSearch) {
    t2 = {
      pathname: cleanedPath,
      search: preservedSearch
    };
    $[4] = cleanedPath;
    $[5] = preservedSearch;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}